<template>
  <div id="contextMenu">
    <ul id="right-click-menu" tabindex="-1" v-if="viewMenu" v-bind:style="{top: top, left: left}" ref="rightMenu">
      <li v-bind:disabled="disableCut" @click="cut">
        <div class="cm-icon"><i class="fa fa-cut"></i></div>
        <div class="cm-text">Cut</div>
        <div class="cm-key">Cmd + x</div>
      </li>
      <li v-bind:disabled="disableCopy" @click="copy">
        <div class="cm-icon"><i class="fa fa-copy"></i></div>
        <div class="cm-text">Copy</div>
        <div class="cm-key">Cmd + c</div>
      </li>
      <li v-bind:disabled="disablePaste" @click="paste" class="cm-group-end">
        <div class="cm-icon"><i class="fa fa-paste"></i></div>
        <div class="cm-text">Paste here</div>
        <div class="cm-key">Cmd + v</div>
      </li>
      <li v-bind:disabled="disableDelete" @click="destroy">
        <div class="cm-icon"><i class="fa fa-trash"></i></div>
        <div class="cm-text">Delete</div>
        <div class="cm-key">Cmd + d</div>
      </li>
    </ul>
  </div>
</template>

<script>
import Vue from 'vue'

export default {
  data () {
    return {
      top: '0px',
      left: '0px'
    }
  },
  props: ['viewMenu', 'disableCut', 'disableCopy', 'disablePaste', 'disableDelete', 'pageX', 'pageY'],
  watch: {
    viewMenu: function () {
      if (this.viewMenu) {
        let vm = this
        Vue.nextTick(function () {
          let largestWidth = window.innerWidth - vm.$refs.rightMenu.offsetWidth - 25
          if (vm.pageX > largestWidth) vm.left = largestWidth
          vm.top = vm.pageY + 'px'
          vm.left = vm.pageX + 'px'
        })
      }
    }
  },
  methods: {
    cut () {
      this.$emit('cut')
    },
    copy () {
      this.$emit('copy')
    },
    paste () {
      this.$emit('paste')
    },
    destroy () {
      this.$emit('delete')
    }
  }
}
</script>

<style lang="scss" scoped>
#right-click-menu li{
  display: flex;
  margin: 0;
  padding: 5px 10px;

  &.cm-group-end {
    border-bottom: 1px solid #E0E0E0;
  }

  .cm-icon {
    flex-basis: 10%;
    text-align: left;
  }
  .cm-text {
    flex-basis: 50%;
  }
  .cm-key {
    flex-basis: 40%;
    text-align: right;
  }
}

#right-click-menu{
  background: #FAFAFA;
  border: 1px solid #BDBDBD;
  box-shadow: 0 2px 2px 0 rgba(0,0,0,.14),0 3px 1px -2px rgba(0,0,0,.2),0 1px 5px 0 rgba(0,0,0,.12);
  display: block;
  list-style: none;
  margin: 0;
  padding: 0;
  position: absolute;
  width: 250px;
  z-index: 999999;
}

#right-click-menu li:last-child {
  border-bottom: none;
}

#right-click-menu li[disabled="disabled"] {
  color: lightgrey;
  &:hover {
    background: #FAFAFA;
    color: lightgrey;
    cursor: default;
  }
}

#right-click-menu li:hover {
  background: #20a8d8;
  color: #FAFAFA;
  cursor: pointer;
}

</style>



// WEBPACK FOOTER //
// src/components/templates/contextMenu.vue